import { Modal, ModalHeading } from "@sainsburys-tech/luna-modal";
import { GridWrapper, GridItem } from "@sainsburys-tech/luna-grid";
import { FormInputLevels } from "../../../Interfaces/IDuTypeFormField";
import { Table } from "@sainsburys-tech/luna-table";
import AutoComplete from "../../SharedComponents/AutoComplete";
import { useEffect, useState } from "react";
import { TextInputField } from "@sainsburys-tech/luna-form";
import { ILinkedContainerFormValueType } from "../../../Types/duTypeFormProps";
import {
  ButtonGroupWrapper,
  FilledButton,
  IconButton,
  OutlinedButton,
} from "@sainsburys-tech/luna-button";
import { Plus, Delete } from "@sainsburys-tech/luna-icons";
import { CheckNotNullAndEmptyAndUndefined } from "../../../helpers/StringHelpersMethods";

const LinkedContainerPopup = (props: any) => {
  const DUPLICATE_ERROR = "Container Type already added";
  const [isAddDisabled, setIsAddDisabled] = useState<boolean>(true);
  const [linkedContainerType, setLinkedContainerType] = useState<string>("");
  const [linkedContainerTypeError, setLinkedContainerTypeError] =
    useState<string>("");
  const [linkedContainerQuantity, setLinkedContainerQuantity] = useState<
    number | ""
  >("");
  const [linkedContainers, setLinkedContainers] = useState<
    ILinkedContainerFormValueType[]
  >(props.linkedContainersData);

  useEffect(() => {
    if (CheckNotNullAndEmptyAndUndefined(linkedContainerType)) {
      const isValid = validateDuplicateContainer(linkedContainerType);
      if (isValid) {
        setLinkedContainerTypeError("");
        if (linkedContainerQuantity > 0) {
          setIsAddDisabled(false);
        }
      } else {
        setIsAddDisabled(true);
        setLinkedContainerTypeError(DUPLICATE_ERROR);
      }
    } else {
      setIsAddDisabled(true);
    }
  }, [linkedContainerType, linkedContainerQuantity]);

  const onAddClick = () => {
    setIsAddDisabled(true);
    const linkedContainerData: ILinkedContainerFormValueType = {
      linkedContainerType: linkedContainerType,
      quantity: linkedContainerQuantity as number,
    };

    if (linkedContainers) {
      const isValid = validateDuplicateContainer(linkedContainerType);
      if (isValid) {
        setLinkedContainers((previousValue) => {
          return [...previousValue, linkedContainerData];
        });
      }
    } else {
      setLinkedContainers([linkedContainerData]);
    }

    setLinkedContainerType("");
    setLinkedContainerQuantity("");
  };

  const onDeleteContainerClick = (containerToBeDeleted: string) => {
    setLinkedContainers(
      linkedContainers.filter(
        (x) => x.linkedContainerType !== containerToBeDeleted
      )
    );
  };

  const onCancelModalClick = (e: any) => {
    props.closeHandler(e);
  };

  const onSaveModalClick = (e: any) => {
    props.onSubmit(e, linkedContainers);
  };

  const validateDuplicateContainer = (containerType: string) => {
    if (linkedContainers) {
      let index = linkedContainers.findIndex(
        (x) => x.linkedContainerType === containerType
      );
      return index === -1;
    } else {
      return true;
    }
  };

  return (
    <>
      {
        <Modal
          small
          handleClose={props.closeHandler}
          open={props.isOpen}
          headingId="info-modal"
          closeElement="Close"
          restrictClose
        >
          <ModalHeading element="h5">Edit Linked Containers</ModalHeading>
          <GridWrapper className="ln-u-push-bottom">
            <GridItem size={{ sm: "1/3", xs: "1" }}>
              <h4 style={{ fontSize: "1.125rem" }}>
                {FormInputLevels.LinkedContainerType}
              </h4>
              <AutoComplete
                apiPath="dutypemaintenance/DuTypeMaintenances"
                className="family-Group-AutoCompleteModal"
                selectedField="ContainerType"
                searchedProperty="ContainerType"
                name={FormInputLevels.LinkedContainerType}
                placeholder="Please select"
                testid="autocomplete-field"
                initialValue={linkedContainerType || ""}
                onSelect={(e: any) => {
                  setLinkedContainerType(e?.data?.ContainerType);
                }}
                filter={`IsLinkableContainer eq true and ContainerType ne '${props.currentContainerType}'`}
                error={linkedContainerTypeError}
              />
            </GridItem>

            <GridItem size={{ sm: "1/3", xs: "1" }}>
              <GridWrapper className="ln-u-push-bottom">
                <GridItem size={{ sm: "1", xs: "1" }}>
                  <TextInputField
                    name="linkedContainerQuantity"
                    label={FormInputLevels.LinkedContainerQuantity}
                    value={linkedContainerQuantity}
                    onChange={(e: any) => {
                      setLinkedContainerQuantity(
                        e.target.value?.replace(/[^0-9]/g, "")
                      );
                    }}
                  />
                </GridItem>
              </GridWrapper>
            </GridItem>

            <GridItem size={{ sm: "1/3", xs: "1" }}>
              <h4 style={{ paddingTop: "0.5rem" }}></h4>
              <ButtonGroupWrapper className="ln-u-hard-top legacyButtonGroup">
                <IconButton
                  variant="filled"
                  label="Add"
                  className=""
                  disabled={isAddDisabled}
                  onClick={onAddClick}
                >
                  <Plus />
                </IconButton>
              </ButtonGroupWrapper>
            </GridItem>
          </GridWrapper>

          <Table
            data={linkedContainers || []}
            columns={[
              {
                name: "Linked Container Type",
                accessor: (rowData: ILinkedContainerFormValueType) => ({
                  value: rowData.linkedContainerType,
                }),
              },
              {
                name: "Quantity",
                accessor: (rowData: ILinkedContainerFormValueType) => ({
                  value: rowData.quantity,
                }),
              },
              {
                name: "",
                accessor: (rowData: ILinkedContainerFormValueType) => ({
                  value: rowData.linkedContainerType,
                }),
                render: ({ value }: { value: string }) => {
                  return (
                    <>
                      <IconButton
                        variant="text"
                        label=""
                        hideLabel
                        title="Delete"
                        onClick={(event: any) => onDeleteContainerClick(value)}
                      >
                        <Delete />
                      </IconButton>
                    </>
                  );
                },
              },
            ]}
          />
          <div className="ln-u-bg-color-white stickyButtonGroup">
            <ButtonGroupWrapper className="ln-u-hard-top ln-u-push-bottom duButtonGroup">
              <OutlinedButton
                className="duButtonGroup-add"
                onClick={(event) => onCancelModalClick(event)}
                type="button"
              >
                Cancel
              </OutlinedButton>
              <FilledButton
                className="duButtonGroup-add"
                type="button"
                onClick={(event) => onSaveModalClick(event)}
              >
                Save
              </FilledButton>
            </ButtonGroupWrapper>
          </div>
        </Modal>
      }
    </>
  );
};

export default LinkedContainerPopup;
